'use strict';
var GEO_DATA, Location, LocationBar, base, isBlank, placeholderState, whichKeyAlias,
  slice = [].slice;

Location = require('../helper/m_location_helper');

GEO_DATA = require('../helper/m_searchbar_helper').GEO_DATA;

placeholderState = require('../helper/m_common').placeholderState;

whichKeyAlias = require('../common/m_keypress').whichKeyAlias;

isBlank = require('../../../../../core/frontend/common/underscore_mixins').isBlank;

module.exports = LocationBar = (function() {
  function LocationBar(arg) {
    var $form, data, division, env, initialLocation, initialLocationData, ref;
    $form = arg.$form, env = arg.env;
    this.$form = $form;
    this.env = env || 'desktop';
    this.previousValue = '';
    this.originalValue = '';
    this.$input = this.$form.find('#ls-location');
    if (!Cookie.get('ell')) {
      if (division = Location.getDivision()) {
        Location.setELLCookie(division.lat + ',' + division.lng);
      }
    }
    initialLocation = Location.getInitialLocation();
    initialLocationData = Location.getInitialLocationData();
    data = {
      manual: false,
      city: (ref = Groupon.division) != null ? ref.name : void 0
    };
    if (initialLocationData) {
      data = Object.assign({}, data, _.pick.apply(_, [initialLocationData, 'lat', 'lng'].concat(slice.call(GEO_DATA))));
    }
    this.$input.data(data);
    if (!isBlank(initialLocation)) {
      placeholderState.set(this.$input, 'hide');
      this.$input.val(initialLocation);
      this.originalValue = initialLocation;
      switch (this.env) {
        case 'mobile':
          $('.t-division-link a').text(initialLocation);
      }
    }
    this.bind();
    switch (env) {
      case 'desktop':
        this.setupDesktop();
        break;
      case 'mobile':
        this.setupMobile();
    }
  }

  LocationBar.prototype.setLocation = LocationBar.val;

  LocationBar.prototype.val = function(value, options) {
    var currentVal, silent;
    if (options == null) {
      options = {};
    }
    silent = options.silent;
    if (value != null) {
      this.$input.val(value).removeClass('prompting');
      if (!silent) {
        return this.trigger('manual', value);
      }
    } else {
      currentVal = this.$input.val();
      if (isBlank(currentVal)) {
        return null;
      }
      return currentVal.trim();
    }
  };

  LocationBar.prototype.bind = function() {
    return this.$input.on({
      'focusin.location': (function(_this) {
        return function() {
          _this.storeLocation();
          if (_this.previousValue === _this.originalValue) {
            _this.$input.val('');
          }
        };
      })(this),
      'focusout.location': (function(_this) {
        return function() {
          _this.storeLocation();
          _this.$input.val(_this.previousValue || _this.originalValue);
          _this.$input.trigger('input.searchGeneral');
        };
      })(this),
      'manual.location': (function(_this) {
        return function() {
          _this.$input.data({
            manual: true
          });
        };
      })(this),
      'input.location': (function(_this) {
        return function() {
          if (_this.$input.data('manual') !== true) {
            _this.$input.trigger('manual');
          }
        };
      })(this)
    });
  };

  LocationBar.prototype.restoreLocation = function() {
    var value;
    if ((value = this.originalValue).length) {
      return this.$input.val(value);
    }
  };

  LocationBar.prototype.storeLocation = function() {
    var value;
    if (!isBlank(value = this.$input.val())) {
      return this.previousValue = value;
    }
  };

  LocationBar.prototype.setupDesktop = function() {};

  LocationBar.prototype.setupMobile = function() {
    return this.$input.on({
      'keydown': (function(_this) {
        return function(e) {
          if (whichKeyAlias(e) === 'Enter') {
            return _this.$form.trigger('submit', 'manual');
          }
        };
      })(this)
    });
  };

  return LocationBar;

})();

if ((base = window.Groupon.Modules).SearchBar == null) {
  base.SearchBar = {};
}

Object.assign(window.Groupon.Modules.SearchBar, {
  LocationBar: LocationBar
});

